import React from 'react';
import { observer } from 'mobx-react';

import { useStyles } from 'ui/base/theme';

import IssueMessages from 'services/pangolin/logic/issues/issue_malicious_domain_messages';
import { IPangolinDomain, MaliciousDomainIssue, Issue } from 'services/pangolin/types';

import { HostDeviceType } from 'services/pangolin/protos/hosts_pb';
import { hostDisplayName, hostDisplayDeviceType } from 'services/pangolin/hosts_service';

import { themedActionIconImageStyles } from 'assets/enums/actions/actions';

import {
  themedDeviceTypeIconImageStyles,
  getDeviceTypeIcon,
} from 'assets/enums/device_types/device_types';

import {
  IssueItemPartialStyles,
  issueItemPartialThemedStyles,

  themedFieldIconImageStyles,
} from './partial_styles';

import Messages from './issue_item_malicious_domain_messages';

type MaliciousDomainIssueItemPartialProps = {
  domain: IPangolinDomain;
  issue: MaliciousDomainIssue;
};
export const MaliciousDomainIssueItemPartial = observer(({ domain, issue }: MaliciousDomainIssueItemPartialProps) => {
  const styles: IssueItemPartialStyles = useStyles(issueItemPartialThemedStyles);

  const fieldIconImages = useStyles(themedFieldIconImageStyles);

  const actionIconImages = useStyles(themedActionIconImageStyles);
  const deviceIconImages = useStyles(themedDeviceTypeIconImageStyles);

  const peer_name = issue.data.domain;
  const peer_icon_img = fieldIconImages.domain;

  const host_host = domain.hosts.getMac(issue.data.mac);
  const host_name = host_host ? (hostDisplayName(host_host) ?? host_host.mac) : issue.data.mac;
  const host_type = host_host ? hostDisplayDeviceType(host_host) : HostDeviceType.H_UNKNOWN;
  const host_icon_img = getDeviceTypeIcon(deviceIconImages, host_type);

  const action_type = JSON.parse((issue as Issue).action);
  const action_name = action_type === 'allow' ? IssueMessages.actionValueAllow() :
                      action_type === 'block' ? IssueMessages.actionValueBlock() :
                      undefined;
  const action_icon_img = action_type === 'allow' ? actionIconImages.allowed :
                          action_type === 'block' ? actionIconImages.blocked :
                          undefined;

  return (
    <>
      <div className={styles.field}>
        <div className={styles.fieldTextLeft}>
          {peer_name}
          <div className={styles.fieldInfo}>
            {Messages.domain()}
          </div>
        </div>
        <img className={styles.fieldIcon} src={peer_icon_img} alt='Peer Icon' />
      </div>
      <div className={styles.field}>
        <div className={styles.fieldTextLeft}>
          {host_name}
          <div className={styles.fieldInfo}>
            {Messages.host()}
          </div>
        </div>
        <img className={styles.fieldIcon} src={host_icon_img} alt='Host Icon' />
      </div>
      <div className={styles.field}>
        <div className={styles.fieldTextLeft}>
          {action_name}
          <div className={styles.fieldInfo}>
            {Messages.action()}
          </div>
        </div>
        <img className={styles.fieldIcon} src={action_icon_img} alt='Action Icon' />
      </div>
    </>
  );
});
